import { Attribute, Relationship, Resource } from 'json-api';
import { Validable } from 'src/app/core/common-behaviors/validate.mixin';
import { Translatable } from 'src/app/translation/translatable';
import { AtomResource } from '../classes/atom-resource';
import { Enum } from './enum.resource';
import { Fraudplatform } from './fraudplatform.resource';
import { PackOffer, PackOfferConfig } from './pack-offer.resource';
import { Platform } from './platform.resource';
import { Product } from './product.resource';
import { ResourceConfig, ResourceConfigAll } from 'src/app/resources/resources-interfaces/resource-config';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';
import { AtomService } from '../atom.service';
import { PlatformConfig } from 'src/app/shared/tools/search/search-config';

const PackMixinBase = Validable(AtomResource);

@Resource({
  type: 'packs',
})
export class Pack extends PackMixinBase {
  @Attribute() name?: Translatable;
  @Attribute({ key: 'commercial_name' }) commercialName?: Translatable;
  @Attribute() data?: string;

  @Relationship() packoffers?: PackOffer[];
  @Relationship() product?: Product;
  @Relationship() enrichments?: Platform[];
  @Relationship() iplookups?: Platform[];
  @Relationship() msisdnlookups?: Platform[];
  @Relationship() otpplatforms?: Platform[];
  @Relationship() fraudplatforms?: Fraudplatform[];
  @Relationship() enumaction?: Enum;
}

export class PackConfig implements ResourceConfig {
  tables?: { columns?: ResourceConfigAll[]; includes?: string[]; } | undefined = {
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        translatable: false,
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'status',
        header: 'Validity',
        displayed: true,
      },
      {
        columnDef: 'name',
        displayedDatas: [
          {
            path: ['name'],
            class: 'mat-body-2',
          },
          {
            path: ['commercialName'],
            class: 'mat-body-1',
          },
        ],
        header: 'Name / Commercial Name',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'name',
      },
      {
        columnDef: 'offers',
        header: 'Offers',
        displayed: true,
        link: {
          resource: 'offers',
          list: 'offers',
          target: 'packoffers.pack',
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ]
  };
  detail = {
    header: {
      icon: 'inventory',
      title: [
        {
          path: ['name', 'commercialName'],
        },
      ],
      id: true,
      validity: true,
    },
    elements: [
      {
        title: 'Offers',
        link: {
          resource: 'offers',
          list: 'offers',
          target: 'packoffers.pack',
        },
        list: [
          {
            APIKey: 'packoffers',
            options: {
              sort: {
                type: 'date',
                editable: new PackOfferConfig(this.atom),
                // displayedDatas: [
                //   {
                //     columnDef: 'name',
                //     path: ['offer.name'],
                //   },
                //   {
                //     columnDef: 'price',
                //     path: ['offer.price'],
                //     class: 'title',
                //     addUnit: {
                //       path: 'offer.currency.id',
                //     },
                //   },
                //   {
                //     columnDef: 'billingmode',
                //     path: [
                //       'offer.billingmode.name',
                //       'offer.recurringperiod.name'
                //     ],
                //   },
                //   {
                //     columnDef: 'providers',
                //     path: [
                //       'offer.enduserproviderjob.firm.name',
                //       'offer.billingproviderjob.firm.name'
                //     ],
                //   },
                // ],
              },
            },
          },
        ],
      },
      {
        title: 'Platforms',
        list: [
          {
            title: 'Enrichments',
            type: 'chips',
            APIKey: 'enrichments',
            value: {
              path: ['id', 'name', 'job.firm.name'],
            },
            link: {
              resource: 'platforms',
              list: 'enrichments',
              target: 'platform',
            },
          },
          {
            title: 'IP Lookups',
            type: 'chips',
            APIKey: 'iplookups',
            value: {
              path: ['id', 'name', 'job.firm.name'],
            },
            link: {
              resource: 'platforms',
              list: 'iplookups',
              target: 'platform',
            },
          },
          {
            title: 'MSISDN Lookups',
            type: 'chips',
            APIKey: 'msisdnlookups',
            value: {
              path: ['id', 'name', 'job.firm.name'],
            },
            link: {
              resource: 'platforms',
              list: 'msisdnlookups',
              target: 'platform',
            },
          },
          {
            title: 'OTP Packs',
            type: 'chips',
            APIKey: 'otpplatforms',
            value: {
              path: ['id', 'name', 'job.firm.name'],
            },
            link: {
              resource: 'platforms',
              list: 'otpplatforms',
              target: 'platform',
            },
          },
          {
            title: 'Fraud',
            type: 'chips',
            APIKey: 'fraudplatforms',
            value: {
              path: ['platform.id', 'platform.name', 'platform.job.firm.name'],
            },
            link: {
              resource: 'platforms',
              list: 'fraudplatforms',
              target: 'platform',
            },
          },
        ],
      },
      {
        title: 'data',
        elements: [
          {
            title: 'Data',
            type: 'data',
            APIKey: 'data',
            value: {
              path: ['data'],
              translatable: false,
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Settings',
        formGroup: 'settings',
        list: [
          {
            type: 'text',
            title: 'Name',
            formControl: 'name',
            translatable: true,
            required: true,
          },
          {
            type: 'text',
            title: 'Commercial Name',
            formControl: 'commercialName',
            translatable: true,
            required: true,
          },
          {
            type: 'validity',
            title: 'Validity',
            formControl: 'validity',
          },
        ]
      },
      {
        title: 'Platforms',
        formGroup: 'platforms',
        list: [
          {
            type: 'resource',
            title: 'Header Enrichment',
            formControl: 'enrichments',
            APIKey: 'enrichments',
            search: new PlatformConfig(this.atom, true),
            required: true,
            noCols: true,
            filter: [{
              key: 'header_enrichment',
              fixValue: true,
            }]
          },
        ]
      }
    ]
  };
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('name', 'Name'),
    new StringFilter('packoffers.offer.name', 'Offer Name'),
    new NumberFilter('packoffers.offer.id', 'Offer ID'),
    new StringFilter('packoffers.offer.country.id', 'Offer Country ID', true),
    new StringFilter('packoffers.offer.country.name', 'Offer Country Name'),
    new StringFilter(
      'packoffers.offer.enduserproviderjob.firm.name',
      'Offer End User Provider'
    ),
    new StringFilter(
      'packoffers.offer.billingproviderjob.firm.name',
      'Offer Billing Provider'
    ),
    new NumberFilter('packoffers.offer.platform.id', 'Offer Platform ID'),
    new StringFilter(
      'packoffers.offer.platform.name',
      'Offer Platform Name'
    ),
    new NumberFilter(
      'packoffers.offer.product.service.ownerfirm.id',
      'Owner firm ID'
    ),
    new StringFilter(
      'packoffers.offer.product.service.ownerfirm.name',
      'Owner firm name'
    ),
  ];
  resource = Pack;
  resourceName?: string | undefined = 'Pack';
  resourceKey?: string | undefined = 'packs';
  resourceKeySingle?: string | undefined = 'pack';
  includes?: string[] | undefined = [
    'packoffers.offer.enduserproviderjob.firm',
    'packoffers.offer.billingproviderjob.firm',
    'packoffers.offer.billingmode',
    'packoffers.offer.recurringperiod',
    'packoffers.offer.currency',
    'enrichments.job.firm',
    'iplookups.job.firm',
    'msisdnlookups.job.firm',
    'otpplatforms.job.firm',
    'fraudplatforms.platform.job.firm',
    'fraudplatforms.enumaction',
  ];
  constructor(private atom: AtomService) {}
}
